import styled from "styled-components";

export const Tabler = styled.div`
    padding: 5px;
    height: 100%;
    width: 100%;
    border-radius: 8px;
    background-color: ${({ theme }) => theme?.table.bg};
    overflow-x: auto;
    font-family: Roboto-Regular;
    border: 1px solid  ${({ theme }) => theme?.table.border};
`

export const CorpoTable = styled.div`
  height: 100%;
  width: 100%;
  overflow-y: auto;
  overflow-x: auto;
`

export const Tabela = styled.table`
  border-collapse: collapse;
  overflow-x: auto;
  width: 100%;
  color: ${({ theme }) => theme?.table.text?.main};
`

export const TabelaCabeca = styled.thead`
  position: sticky;
  top: 0px;
  z-index: 2;
  background-color: ${({ theme }) => theme?.table.bg};
  outline: 1px solid #dddddd;

  tr {
      text-align: left;
      background-color: inherit;
      line-height: 40px;
      font-size: 14px;


      & > th {
        min-width: 25px;
        max-width: max-content;
      }

      & > th:nth-child(2) {
        position: sticky;
        background-color: inherit;
        left: 0;
        padding-left:5px;
      }
    };


`

export const TabelaCorpo = styled.tbody`
  tr:hover, tr:nth-child(even):hover {
      color: ${({ theme }) => theme?.table.text?.hover};
      background-color: ${({ theme }) => theme?.table.bghover};
    }

  tr:hover > td:nth-child(2), tr:nth-child(even):hover > td:nth-child(2) {
    color: ${({ theme }) => theme?.table.text?.hover};
    background-color: ${({ theme }) => theme?.table.bghover};
  }

  tr {
    cursor: pointer;

      border-radius: 5px;
      background-color: ${({ theme }) => theme?.table.line.main};
      border-bottom: 1px solid #dddddd;

      td:nth-child(2) {
        position: sticky;
        left: 0;
        background-color: ${({ theme }) => theme?.table.line.main};
      }

      td {
        word-break: keep-all;
        padding-right: 5px;
        line-height: 40px;
        min-width: 25px;
        max-width: max-content;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
      }
  }

  tr:nth-child(even) {
    background-color: ${({ theme }) => theme?.table.line.even};

    td:nth-child(2) {
      background-color: ${({ theme }) => theme?.table.line.even};
      }
  }
`
